import moment from 'moment-timezone';

export const formatTime = (props) => {
  const { time_from, time_from_tz, time_to_tz, time_to } = props;

  const momentFrom = time_from_tz ? moment(time_from).tz(time_from_tz) : moment(time_from);
  const momentTo = time_to_tz ? moment(time_to).tz(time_to_tz) : moment(time_to);

  if (
    momentFrom.isSame(momentTo, 'day') &&
    momentFrom.isSame(momentTo, 'hour') &&
    momentFrom.isSame(momentTo, 'minute')
  ) {
    return `${momentFrom.format('HH:mm')}`;
  }

  return `${momentFrom.format('HH:mm')} - ${momentTo.format('HH:mm')}`;
};
